/**
 * @returns {boolean}
 */
export default function(){
    return typeof window !== "undefined"
}